import { render, staticRenderFns } from "./specialDetail.vue?vue&type=template&id=66a78f36&scoped=true&"
import script from "./specialDetail.vue?vue&type=script&lang=js&"
export * from "./specialDetail.vue?vue&type=script&lang=js&"
import style0 from "./specialDetail.vue?vue&type=style&index=0&id=66a78f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a78f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
